
import React, { Component } from 'react';
import Alert from "./alert/alert.jsx";
import Footer from "./footer/index.jsx";
import "./investormy.css";

export default class marketrisk extends Component {
    open(v) {
        Alert.open(true)
    }
    render() {
        return (
            <div >
                <div>
                    <div className="">
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                            </div>
                            {/*<div id="maincontent" style="margin-left:40px;margin-right:40px;padding-top:40px;">*/}
                            <div id="maincontent" style={{ marginLeft: 10, marginRight: 10, marginBottom: 60 }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css" />*/}
                                        {/* <title>Call Vs Put</title> */}
                                        <div className="contentbox">
                                            <p>An adverse movement in any of a warrant's pricing variables - share price, time to expiry, volatility, interest rate and expected dividends - can have a negative impact on the warrant price.</p>
                                            <div className="imgholder">
                                                <img src="/img/education/marketrisk1.png" style={{ maxWidth: '365px' }} />
                                            </div>
                                            <p>When buying a warrant or any other investment product that is linked to the movements of a market, an investor is exposed to the risk that the share price, index futures or market as a whole moves adversely against them. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}